"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UvodniHeroSluzby() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="úvodní-hero-služby" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/solar_roof_pristine_sunlight.png)] transition-transform duration-[8000ms] ease-out" style={{
      transform: heroVisible ? "scale(1.05)" : "scale(1)"
    }} />

      {}
      <div className="absolute inset-0 surface-overlay" />

      {}
      <div ref={heroRef} className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {}
        <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold mb-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Maximální ochrana a čistota vaší střechy
        </h1>

        {}
        <p className={`text-lg md:text-xl lg:text-2xl text-muted-foreground mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Profesionální čištění střech, fasád a chodníků. Kompletní realizace
          fotovoltaických systémů na klíč.
        </p>

        {}
        <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-200 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="btn-primary group relative overflow-hidden">
              <span className="relative z-10">Kalkulace zdarma</span>
              <span className="absolute inset-0 bg-linear-to-r from-primary-hover to-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] origin-left" />
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="size-8 text-primary opacity-80" />
      </div>
    </section>;
}